module.exports = __webpack_public_path__ + "static/img/AGC_H5.2cce30a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/AGC_H5.png
// module id = /acG
// module chunks = 34